<template>
    <Head :title="'Utilisateur N°'+ userShow.code" />

    <UserLayout :userShow="userShow" :roles="roles" :currency="currency">
        <div x-data="handleSelect">
            <Datatables backgroundClass="bg-primaryOrange" textClass="text-gray-800">
                <template #title>
                    Liste des articles
                    <span class="font-medium">({{ items.total }})</span>
                </template>
                <template #headerButtons>
                    <button class="rounded-md py-1 px-2 bg-white text-primaryOrange hover:bg-primaryOrange-300 hover:text-white"
                        @click="showSearchModal" title="Rechercher"
                    ><i class="fad fa-search"></i>
                    </button>
                </template>
                <template #tableHeader>
                    <th>#</th>
                    <th>Référence</th>
                    <th>Nom</th>
                    <th>Prix</th>
                    <th>Statut</th>
                    <th>&nbsp;</th>
                </template>
                <template #tableBody>
                    <template v-if="!items.data.length">
                        <tr>
                            <td colspan="7">
                                <div class="text-center text-2xl text-red-400 bg-red-100 p-10">
                                    <b>{{ userShow.name }}</b> n'a encore effectué aucun achat d'articles pour le moment.
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else v-for="(item, index) in items.data" :key="item.id">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td>
                                <span class="font-bold text-primaryOrange">{{ item.reference }}</span>
                            </td>
                            <td>{{ item.short_name }}</td>
                            <td>
                                <div class="text-right font-bold"
                                    :class="item.balance > 0 ? 'text-gray-400' : 'text-primaryOrange'"
                                >{{ formatAmount(item.price, currency) }}</div>
                            </td>
                            <td><StatusBadge :label="item.status_text" :color="item.status_color" /></td>
                            <td>
                                <Link class="flex justify-end" title="Détails"
                                    :href="route('travels.items.index', item.travel) + '?filter[reference]=' + item.reference"
                                >
                                    <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                        <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                        <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                    </svg>
                                </Link>
                            </td>
                        </tr>
                    </template>
                </template>
            </Datatables>
        </div>

        <Pagination :links="items.links" />

        <jet-dialog-modal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Rechercher un article</template>
            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </jet-dialog-modal>
    </UserLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import UserLayout from '@/Layouts/UserLayout.vue'
    import Pagination from '@/Components/Pagination'
    import Datatables from '@/Components/Datatables'
    import StatusBadge from '@/Components/StatusBadge'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import DateFormatMixins from '@/Mixins/DateFormatMixins'
    import SearchActionMixins from '@/Mixins/SearchActionMixins'

    export default defineComponent({
        components: {
            Head,
            Link,
            UserLayout,
            Pagination,
            Datatables,
            StatusBadge,
            GlobalFilter,
            JetDialogModal
        },

        mixins: [ CurrencyMixins, SearchActionMixins, DateFormatMixins],

        props: {
            roles: Object,
            userShow: Object,
            currency: Object,
            items: Object
        },
    })
</script>

